import { useEffect, useState } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { Fire } from '@phosphor-icons/react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Iter23 G2 — Streak badge. Hidden when streak < 2.
 * Premio "1 lavaggio Standard falas" si sblocca a streak = 5 (4 settimane fatte + questa).
 */
export default function StreakBadge() {
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/customer/streak`, { withCredentials: true });
        setData(r.data);
      } catch (err) { if (err?.response?.status !== 401) console.warn('[Streak] load failed', err?.response?.status || err?.message); }
    })();
  }, []);

  if (!data || data.streak_weeks < 2) return null;

  const remaining = Math.max(0, (data.next_threshold || 4) - data.streak_weeks);
  const messageBase = remaining === 0
    ? 'Premio i zhbllokuar! 1 larje Standard falas të disponueshme.'
    : `Edhe ${remaining} jav${remaining === 1 ? 'ë' : 'ë'} dhe fiton 1 larje Standard falas`;

  return (
    <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}
                className="px-4" data-testid="streak-badge">
      <div className="p-3 rounded-2xl bg-gradient-to-br from-[#FF5A00]/15 via-[#FFD700]/10 to-transparent border border-[#FF5A00]/30">
        <div className="flex items-center gap-2.5">
          <div className="w-10 h-10 rounded-xl bg-[#FF5A00]/20 flex items-center justify-center">
            <Fire size={18} weight="fill" className="text-[#FF5A00]" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-bold text-white">
              {data.streak_weeks} javë radhazi!
            </p>
            <p className="text-xs text-white/65 leading-snug">{messageBase}</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
